export interface BatchStatisticsPageLoadRequest {
  batchType: string
}

export function BatchStatisticsPageLoadRequestToJSON(
  value: BatchStatisticsPageLoadRequest
): any {
  return {
    batch_type: value.batchType
  }
}
